import { axiosInstance } from ".";

const getStandardAdmins = async (params) =>
  await axiosInstance.get("/admins", { params });

const addStandardAdmin = async (data) =>
  await axiosInstance.post("/admins", data);

const sendResetPasswordEmail = async (data) =>
  await axiosInstance.post("/admins/send_reset_password_email", data);

export { getStandardAdmins, addStandardAdmin, sendResetPasswordEmail };
